import { IconPencil } from "@tabler/icons-react"
import { type FC, useEffect, useState } from "react"

import { parseNumber } from "@forento/core/utilities/number"
import Form from "@forento/ui/components/Form"

import Button, { SecondaryButton } from "~/components/button"
import { Input } from "~/components/input"
import { query } from "~/utilities/trpc"

type Props = { course: { id: string; price: number | null }; reload(): Promise<unknown> }
const Price: FC<Props> = ({ course, reload }) => {
	const [isEditing, setEditing] = useState(false)
	const [price, setPrice] = useState(course.price?.toString() ?? "")

	useEffect(() => {
		setPrice(course.price?.toString() ?? "")
	}, [course.price])

	const updateCourse = query.updateCourse.useMutation({
		async onSuccess() {
			await reload()
			setEditing(false)
		},
		onError: error => console.error(error),
	})

	return (
		<div>
			<div className="mb-2 flex items-center gap-2">
				<h2 className="font-semibold text-slate-800">💰 Pris</h2>
				{!isEditing && (
					<button
						type="button"
						className="text-primary hover:text-primary/80 cursor-pointer"
						onClick={() => setEditing(true)}
					>
						<IconPencil className="size-4" />
					</button>
				)}
			</div>
			{!isEditing ? (
				<div>
					<p className="text-base leading-relaxed tracking-wider text-slate-700">
						{course.price !== null ? `${course.price.toFixed(2)} kr` : "Gratis"}
					</p>
					{course.price !== null && (
						<p className="mt-2 text-sm text-slate-600">Medlemmar har 15% rabatt på valt pris</p>
					)}
				</div>
			) : (
				<Form
					onSubmit={() => {
						const priceValue = parseNumber(price)
						updateCourse.mutate({ id: course.id, price: (priceValue ?? 0) <= 0 ? null : priceValue })
					}}
					className="flex flex-col gap-4"
				>
					<div className="flex items-center gap-2">
						<Input
							type="number"
							value={price}
							onChange={setPrice}
							placeholder="Ange pris (t.ex. 299)"
							autoFocus
							className="flex-1"
						/>
						<span className="text-sm text-slate-500">kr</span>
					</div>
					<p className="text-sm text-slate-600">Medlemmar har 15% rabatt på valt pris</p>
					<div className="flex gap-4">
						<Button type="submit" color="green" disabled={updateCourse.isPending}>
							{updateCourse.isPending ? "Sparar..." : "Spara"}
						</Button>
						<SecondaryButton onClick={() => setEditing(false)}>Avbryt</SecondaryButton>
					</div>
				</Form>
			)}
		</div>
	)
}

export default Price
